{
  "name": "2024-csp-frontend",
  "version": "1.8.13",
  "scripts": {
    "preinstall": "node scripts/preinstall-check.mjs",
    "ng": "ng",
    "start": "ng serve",
    "start-docker": "ng serve --host 0.0.0.0",
    "build-production": "CI=1 ng build --base-href / --configuration=production  --output-path=dist/production",
    "build-staging": "CI=1 ng build --base-href / --configuration=staging  --output-path=dist/staging",
    "build-sw": "ng build --base-href / --configuration=sw --output-path=dist/sw",
    "test": "ng test",
    "lint": "ng lint",
    "upload-production-sourcemaps": "bugsnag-source-maps upload-browser --overwrite \\\n  --api-key 04619d853cf6fd06f777317ffba84e5d \\\n  --app-version $npm_package_version \\\n  --base-url \"*\" \\\n  --directory dist/production || true",
    "upload-staging-sourcemaps": "bugsnag-source-maps upload-browser --quiet --overwrite --api-key 04619d853cf6fd06f777317ffba84e5d --app-version ${npm_package_version}-staging --base-url \"*\" --directory dist/staging || true",
    "version": "PACKAGE_VERSION=$npm_package_version && echo $PACKAGE_VERSION > VERSION && git add VERSION",
    "postversion": "git push && git push --tags",
    "deploy": "./scripts/deploy.sh",
    "remove": "node -r ./scripts/load-aws-profile.js ./node_modules/.bin/sst remove",
    "unlock": "node scripts/assume-role.js && node -r ./scripts/load-aws-profile.js ./node_modules/.bin/sst unlock",
    "invalidate-cache": "./scripts/invalidate-cache.sh"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.1",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@bugsnag/js": "^8.0.0",
    "@bugsnag/plugin-angular": "^8.0.0",
    "@fortawesome/fontawesome-pro": "^6.7.2",
    "@hutsix/ngxh6": "^5.1.0",
    "@ng-bootstrap/ng-bootstrap": "~21.0.0",
    "@openapitools/openapi-generator-cli": "^2.7.0",
    "bootstrap": "5.3.8",
    "echarts": "^6.0.0",
    "geolib": "^3.3.4",
    "leaflet": "^1.9.4",
    "moment-timezone": "^0.5.48",
    "ngx-dropzone-wrapper": "~13.0.0",
    "ngx-indexed-db": "^11.0.2",
    "ngx-moment": "^6.0.2",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular/build": "^22.1.2",
    "@angular/cli": "^22.1.2",
    "@angular/compiler-cli": "^22.1.0",
    "@angular/localize": "^22.1.0",
    "@aws-sdk/client-sts": "^3.1027.0",
    "@bugsnag/source-maps": "^2.0.0",
    "@compodoc/compodoc": "^1.1.11",
    "@types/aws-lambda": "^8.10.161",
    "@types/jasmine": "~3.10.3",
    "@types/node": "^24",
    "angular-eslint": "^22.1.0",
    "eslint": "^9.0.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "jasmine-core": "~4.0.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "nodemon": "^2.0.19",
    "opn": "^6.0.0",
    "prettier": "^3.0.0",
    "sst": "^4.6.11",
    "ts-node": "~10.9.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.66.0",
    "yalc": "^1.0.0-pre.53"
  }
}
